// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetFastenersCollectionApiParameter } from "@store/Framework/Services/FastenerSercice";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import FastenersTableState from "@store/Framework/Store/Store/Components/FastenersTable/FastenersTableState";
import { Draft } from "immer";

const initialState: FastenersTableState = {
    getFastenersApiParameter: {
        productId: "",
    },
};

const actions = {
    "Store/Components/FastenersTable/UpdateSearchFields": (
        draft: Draft<FastenersTableState>,
        action: { parameter: GetFastenersCollectionApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getFastenersApiParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getFastenersApiParameter = {
                ...initialState.getFastenersApiParameter,
                ...action.parameter,
            };
        } else {
            draft.getFastenersApiParameter = {
                ...draft.getFastenersApiParameter,
                ...action.parameter,
            };

            for (const key in draft.getFastenersApiParameter) {
                const value = (<any>draft.getFastenersApiParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getFastenersApiParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getFastenersApiParameter.page &&
                    draft.getFastenersApiParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize" &&
                    key !== "productId"
                ) {
                    draft.getFastenersApiParameter.page = 1;
                }
            }
        }
    },
    "Store/Components/FastenersTable/ResetSearchFields": (draft: Draft<FastenersTableState>) => {
        return initialState;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type FastenersTableActions = Parameters<typeof reducer>[1];
export default reducer;
